import React from 'react';
import ReactDOM from 'react-dom';
import Root from './root';
import store from './store';
import './index.css';

ReactDOM.render(
  <Root store={store} />,
  document.getElementById('root')
);

if (module.hot) {
  module.hot.accept('./root', () => {
    const NextRoot = require('./root').default;
    ReactDOM.render(
      <NextRoot store={store} />,
      document.getElementById('root')
    );
  });
}



// WEBPACK FOOTER //
// ./src/index.js